export default __webpack_public_path__ + "static/media/br.33b38c32.svg";